/**
 * Help / How to Guide: section definitions for sidebar navigation.
 * Sections align to docs/HOW_TO_GUIDE.md. All users can access; no auth required.
 */

export const HELP_PORTAL_PATH = '/help'

export type HelpSectionId =
  | 'welcome'
  | 'user-types'
  | 'getting-started'
  | 'normal-users'
  | 'broadcasters'
  | 'ad-creators'
  | 'moderators'
  | 'admins'
  | 'routes'
  | 'accessibility-support'

export interface HelpSection {
  id: HelpSectionId
  label: string
  path: string
}

/** Help sections in nav order. */
export const HELP_SECTIONS: HelpSection[] = [
  { id: 'welcome', label: 'Welcome', path: `${HELP_PORTAL_PATH}/welcome` },
  { id: 'user-types', label: 'User types at a glance', path: `${HELP_PORTAL_PATH}/user-types` },
  { id: 'getting-started', label: 'Getting started', path: `${HELP_PORTAL_PATH}/getting-started` },
  { id: 'normal-users', label: 'Normal users', path: `${HELP_PORTAL_PATH}/normal-users` },
  { id: 'broadcasters', label: 'Broadcasters', path: `${HELP_PORTAL_PATH}/broadcasters` },
  { id: 'ad-creators', label: 'Ad-Creators', path: `${HELP_PORTAL_PATH}/ad-creators` },
  { id: 'moderators', label: 'Moderators', path: `${HELP_PORTAL_PATH}/moderators` },
  { id: 'admins', label: 'Admins', path: `${HELP_PORTAL_PATH}/admins` },
  { id: 'routes', label: 'Quick reference: routes', path: `${HELP_PORTAL_PATH}/routes` },
  { id: 'accessibility-support', label: 'Accessibility and support', path: `${HELP_PORTAL_PATH}/accessibility-support` },
]

export function getHelpSectionById(id: string | undefined): HelpSection | undefined {
  if (!id) return undefined
  return HELP_SECTIONS.find((s) => s.id === id)
}
